import { Home, ScrollText, CalendarDays, BookOpen, FileText } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const ITEMS = [
  { id: "accueil", label: "Accueil", icon: Home, testId: "nav-accueil" },
  { id: "histoire", label: "Histoire", icon: ScrollText, testId: "nav-histoire" },
  { id: "programme", label: "Programme", icon: CalendarDays, testId: "nav-programme" },
  { id: "hommage", label: "Hommage", icon: BookOpen, testId: "nav-hommage" },
  { href: "/documents", label: "Documents", icon: FileText, testId: "nav-documents" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 md:hidden"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <div className="flex items-center justify-around rounded-2xl border border-stone-200/80 bg-white/90 py-2 shadow-lg backdrop-blur-xl">
        {ITEMS.map((item) => (
          <button
            key={item.label}
            data-testid={item.testId}
            onClick={() => (item.href ? (window.location.href = item.href) : scrollToId(item.id))}
            className="flex flex-col items-center gap-1 px-2 py-1 text-stone-500 transition-colors duration-300 active:text-[#C85A32]"
          >
            <item.icon className="h-5 w-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
